export default __webpack_public_path__ + "static/media/DEEP.ab572ff9.png";